document.querySelectorAll(".collapsible-content .grid__item").forEach(function(group) {
  const summaries = group.querySelectorAll("details summary");

  summaries.forEach(function(summary) {
    summary.addEventListener("click", function(event) {
      const clickedDetails = this.parentElement;
      const isAlreadyOpen = clickedDetails.hasAttribute("open");

      // Close all <details> in the group and reset icons
      group.querySelectorAll("details").forEach(function(details) {
        details.removeAttribute("open");

        const plusIcon = details.querySelector(".plus-icon-accordion");
        const minusIcon = details.querySelector(".minus-icon-accordion");

        if (plusIcon) plusIcon.style.display = "inline-block";
        if (minusIcon) minusIcon.style.display = "none";
      });

      // If not already open, open it and toggle icons
      if (!isAlreadyOpen) {
        clickedDetails.setAttribute("open", true);

        const plusIcon = clickedDetails.querySelector(".plus-icon-accordion");
        const minusIcon = clickedDetails.querySelector(".minus-icon-accordion");

        if (plusIcon) plusIcon.style.display = "none";
        if (minusIcon) minusIcon.style.display = "inline-block";
      }

      // Prevent default behavior
      event.preventDefault();
    });
  });
});
